import { render, staticRenderFns } from "./Storage.vue?vue&type=template&id=e5015c0a&scoped=true&"
import script from "./Storage.vue?vue&type=script&lang=js&"
export * from "./Storage.vue?vue&type=script&lang=js&"
import style0 from "./Storage.vue?vue&type=style&index=0&id=e5015c0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5015c0a",
  null
  
)

export default component.exports